// extracted by mini-css-extract-plugin
export default {"imageWrapper":"RH-z","twoColumnImage":"SH-z"};